<script>
  export let element;
</script>

<div class="swiper-pagination-wrap">
  <div class="swiper-pagination" bind:this={element} />
</div>

<style lang="scss">
  .swiper-pagination {
    &-wrap {
      margin: 4rem 0 0;

      display: flex;
      justify-content: center;
    }

    display: flex;
    align-items: center;
    gap: 2.2rem;

    position: initial;
    padding: 1rem 2rem;
    width: auto;

    border: 1px solid $light-border;
    border-radius: 4rem;

    :global &.swiper-pagination-lock {
      display: none;
    }

    :global .swiper-pagination-bullet {
      opacity: 1;
      cursor: pointer;

      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      background: transparent;

      width: 0.7rem;
      height: 0.7rem;

      &::after {
        content: '';

        opacity: 0.3;
        display: block;

        width: 0.3rem;
        height: 0.3rem;

        background-color: var(--royal);
        border-radius: 50%;

        transition: all 0.2s;
      }

      &-active {
        &::after {
          opacity: 1;

          width: 0.7rem;
          height: 0.7rem;
        }
      }
    }
  }
</style>
